import { CurrenciesInterface } from '../interfaces/deposit.interface';
import { CurrencyBalance } from '../interfaces/wallet.interface';

/**
 * 已存款且未 KYC 玩家預設幣種：
 * 1. 依 getUserbalance 順序，取第一個有餘額且商戶可見的幣種
 * 2. 若皆無餘額，取 userSetting.defaultCurrencyType（貨幣選擇器啟用幣）
 * 3. 仍無則取錢包列表中第一個商戶可見幣種
 *
 * @param balances getUserbalance 回傳的錢包幣種列表
 * @param preferredCode userSetting.defaultCurrencyType
 * @param visibleCurrencies 商戶可見幣種列表
 * @returns 解析後的預設幣種代碼，無匹配則 null
 */
export function resolveDepositedDefaultCurrency(
  balances: CurrencyBalance[],
  preferredCode: string | undefined,
  visibleCurrencies: CurrenciesInterface[],
): string | null {
  const visibleCodes = new Set(visibleCurrencies.filter(c => c.isVisible).map(c => c.currency));
  const walletCodes = new Set(balances.map(b => b.currency));

  const withBalance = balances.find(b => visibleCodes.has(b.currency) && b.balance > 0);
  if (withBalance) return withBalance.currency;

  const preferredCurrency =
    preferredCode && visibleCodes.has(preferredCode) && walletCodes.has(preferredCode) ? preferredCode : null;
  if (preferredCurrency) return preferredCurrency;

  const depositedCurrency = balances.find(b => visibleCodes.has(b.currency));
  if (depositedCurrency) return depositedCurrency.currency;

  return null;
}
